// 初始化项目的时候填入的变量, 请谨慎修改, 会影响各个地方的使用
export var componentName = 'CnLowcodePage';
export var libraryName = 'cn-lowcode-page';
export var componentNameForUrlPage = 'CnLowcodePageViaUrl';
export var componentNameForCdnComponent = 'CnLowcodeCdnComponent';